var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank-selection-flow"},[(!_vm.sourceName)?[_c('riseup-header'),_vm._v(" "),_c('bank-selection',{attrs:{"on-selection":_vm.bankSelection}})]:[(_vm.isDiscountSource)?_c('discount-flow'):_c('bank-connection-flow')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }